import styled from "styled-components";

export const StatusFilterWrapper = styled.div`
  position: absolute;
  top: 12rem;
  left: 50%;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100rem;
  min-width: 88rem;
  padding: var(--Spacing-16, 1.6rem);
  gap: var(--Spacing-20, 2rem);
  box-shadow: 0 0.4rem 1.2rem 0 rgba(7, 68, 161, 0.04);
  transform: translate(-50%, 0%);
  z-index: 30;
`;

export const StatusFilterContentWrapper = styled.div`
  padding: 0 0.8rem 0.4rem 0.8rem;
`;

export const StatusFilterTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  &:first-child {
    border-top: none;
    padding-top: 0;
    padding-bottom: 2rem;
  }
  &:last-child {
    border-bottom: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
    padding-bottom: 0;
  }
`;

export const StatusFilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.2rem;
  padding: 2rem 0;
  flex-wrap: wrap;
  border-bottom: 1px solid ${({ theme }) => theme.color.neural.gray02};

  &:first-child {
    border-top: none;
    padding-top: 0;
    padding-bottom: 2rem;
  }
  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const StatusFilterSectionWrapper = styled.div`
  :last-child {
    padding-bottom: 0;
  }
`;

export const StatusFilterTitle = styled.h3`
  display: flex;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 145%;
  color: ${({ theme }) => theme.color.neural.gray09};
  margin: 0;
`;

export const StatusFilterTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1.2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);
`;

export const ClassificationCloseButton = styled.button`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ClassificationXMark = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
`;

export const ClassificationCloseText = styled.span`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 100%;
  color: ${({ theme }) => theme.color.live.orange};
`;

export const FilterResetButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  cursor: pointer;

  &:disabled {
    cursor: no-drop;
    span {
      color: ${({ theme }) => theme.color.neural.gray05};
    }
  }
`;

export const FilterResetButtonText = styled.span`
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  color: #515c6c;
`;

export const ConfirmButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ConfirmButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  height: 3.2rem;
  margin-top: 2rem;
  background-color: #1baefe;
  border-radius: 0.8rem;
  padding: 0 1.6rem;
  cursor: pointer;
`;

export const ConfirmButtonText = styled.span`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 100%;
  color: white;
`;
